import { AllSoakStyleResponse, SoakStyleDropDownDto, SoakStyleDto, SoakStyleResponse } from '@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { SoaksRepository } from './dto/soak-style.repo';
import { SoaksAdapter } from './dto/soaks.adapter';
import { SoaksDTO } from './dto/soaks.dto';
import { SoakStylesRequest } from './dto/soaks.request';
import { SoakStyleEntity } from './soaks.entity';
import { ErrorResponse } from '@gtpl/shared-models/common-models';

@Injectable()
export class SoakService {
    constructor(
        private adapter: SoaksAdapter,
        private soaksRepository: SoaksRepository
    ) { }

    async createSoaks(soaksDTO: SoaksDTO, isUpdate: boolean, request: Request): Promise<SoakStyleResponse> {
        try {

            if (!isUpdate) {
                const soaksEntity = await this.getallsoakstyleData(soaksDTO.soakstyle);
                if (soaksEntity) {
                    throw new SoakStyleResponse(false, 11104, 'Soaks Style already exists');
                }
            }
            else {
                const soaksEntity = await this.getallsoakstyleData(soaksDTO.soakstyle);
                if (soaksEntity) {
                    if (soaksEntity.soakstyleId != soaksDTO.soakstyleId) {
                        throw new SoakStyleResponse(false, 11104, 'Soaks Style  already exists');
                    }
                }
            }
            const convertedsoaksEntity: SoakStyleEntity = this.adapter.convertDtoToEntity(soaksDTO, isUpdate);
            const savedsoaksEntity: SoakStyleEntity = await this.soaksRepository.save(convertedsoaksEntity);
            const savedsoaksDTO: SoaksDTO = this.adapter.convertEntityToDto(savedsoaksEntity); 

            if (savedsoaksDTO) {
                const response = new SoakStyleResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'Soaks Style  Updated Successfully' : 'Soaks Style Created Successfully', savedsoaksDTO);
                return response; 
            } else {
                throw new SoakStyleResponse(false, 11106, 'SoaksStyle saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }

    async updateSoaksStyles(soakStyle: SoakStyleDto): Promise<CommonResponse> {
        try {
          const soakDto = await this.getSoaksById(soakStyle.soakstyleId);
    
          if (soakDto) {
    
            await this.soaksRepository.update({ soakstyleId: soakDto.soakstyleId }, {
              ...soakStyle,
            });
    
            const updatedDto: SoakStyleDto = this.adapter.convertEntityToDto({
              ...soakDto,
              ...soakStyle,
            });
    
            return new CommonResponse(true, 10115, ' updated successfully', updatedDto);
          } else {
            throw new ErrorResponse(99998, 'No Records Found');
          }
        } catch (err) {
          return err;
        }
      }


    async getallsoakstyleData(soakstyle: string): Promise<SoakStyleEntity> {

        const response = await this.soaksRepository.findOne({
            where: { soakstyle: soakstyle },
        });
        
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getAllSoaks(): Promise<AllSoakStyleResponse> {
        try {
            const soaksDTO: SoaksDTO[] = [];

            const soaksEntities: SoakStyleEntity[] = await this.soaksRepository.find({
                order: { soakstyle: "ASC" },
            });

            if (soaksEntities.length > 0) {
                soaksEntities.forEach(soaksEntity => {
                    const convertedsoaksDTO: SoaksDTO = this.adapter.convertEntityToDto(soaksEntity);
                    soaksDTO.push(convertedsoaksDTO);
                });
                const response = new AllSoakStyleResponse(true, 11208, "SoaksStyle retrieved successfully", soaksDTO);
                return response;
            } else {
                
                throw new SoakStyleResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    async activateOrDeactivateSoakStyle(soaksReq: SoakStylesRequest): Promise<SoakStyleResponse> {
        try {
            const soackExists = await this.getSoaksById(soaksReq.soakstyleId);
            if (soackExists) {
                if (soaksReq.versionFlag !== soackExists.versionFlag) {
                    throw new SoakStyleResponse(false, 10113, 'Someone updated the current soaks information.Refresh and try again');
                } else {

                    const soakStatus = await this.soaksRepository.update(
                        { soakstyleId: soaksReq.soakstyleId },
                        { isActive: soaksReq.isActive, updatedUser: soaksReq.updatedUser });

                    if (soackExists.isActive) {
                        if (soakStatus.affected) {
                            const trimsResponse: SoakStyleResponse = new SoakStyleResponse(true, 10115, 'Soaks is de-activated successfully');
                            return trimsResponse;
                        } else {
                            throw new SoakStyleResponse(false, 10111, 'Soaks is already deactivated');
                        }
                    } else {
                        if (soakStatus.affected) {
                            const SoakStylesResponse: SoakStyleResponse = new SoakStyleResponse(true, 10114, 'Soaks is activated successfully');
                            return SoakStylesResponse;
                        } else {
                            throw new SoakStyleResponse(false, 10112, 'Soaks is already  activated');
                        }
                    }
                    
                }
            } else {
                throw new SoakStyleResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getSoaksById(soakstyleId: number): Promise<SoakStyleEntity> {
    
        const response = await this.soaksRepository.findOne({
            where: { soakstyleId: soakstyleId },
        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getAllSoaksDropDown(): Promise<CommonResponse> {
        try {
            const soackDto: SoakStyleDropDownDto[] = [];
            
            const soackEntities: SoakStyleEntity[] = await this.soaksRepository.find({
                order: { soakstyle: "DESC" }, where: { isActive: true }
            });
            if (soackEntities.length > 0) {
                soackEntities.forEach(soackEntity => {
                    const convertedsoackDto = new SoakStyleDropDownDto(soackEntity.soakstyleId, soackEntity.soakstyle);
                    soackDto.push(convertedsoackDto);
                });
                const response = new CommonResponse(true, 11208, "Soaks retrieved successfully", soackDto);
                return response;
            } else {
                throw new SoakStyleResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getSoaksInfoById(soakstyleId: number): Promise<CommonResponse> { 
        try {
            const Response = await this.soaksRepository.findOne({
                where: { soakstyleId: soakstyleId },
            });

            if (Response) {
                return new CommonResponse(true, 11111, 'soack Info Retrieved Successfully', Response);
            } else {
                return new CommonResponse(false, 99999, 'Not Found');
            }
        } catch (error) {
            return error;
        }
    }


    async getAllSoakStyles(): Promise<CommonResponse> {
        const records = await this.soaksRepository;
        const query = `SELECT soack_style_id AS soakstyleId , soack_style AS soakstyle ,is_active AS isActive ,created_user AS createdUser, created_at AS createdAt ,
        updated_at AS updatedAt ,updated_user AS updatedUser , version_flag AS versionFlag FROM soack_styles`
        const result = await this.soaksRepository.query(query)
        if (result) {
            return new CommonResponse(true, 1, "Data Retrived", result)
        }
        else {
            return new CommonResponse(false, 0, "No Data", [])
        }
    }



}
